import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=0af98340&scoped=true"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"
import style0 from "./ProfileEdit.vue?vue&type=style&index=0&id=0af98340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af98340",
  null
  
)

export default component.exports